var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeScanner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18C5 18.5523 5.44772 19 6 19H10V21H6C4.34315 21 3 19.6569 3 18V14H5V18ZM21 18C21 19.6569 19.6569 21 18 21H14V19H18C18.5523 19 19 18.5523 19 18V14H21V18ZM9 17H7V7H9V17ZM13 17H11V7H13V17ZM17 17H15V7H17V17ZM10 5H6C5.44772 5 5 5.44772 5 6V10H3V6C3 4.34315 4.34315 3 6 3H10V5ZM18 3C19.6569 3 21 4.34315 21 6V10H19V6C19 5.44772 18.5523 5 18 5H14V3H18Z",
    fill: "#70707C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeScanner);
export default __webpack_public_path__ + "static/media/Barcode Scanner.81f1d68f6ae6bed14483a86eb6fd4767.svg";
export { ForwardRef as ReactComponent };